import { render, staticRenderFns } from "./submitPay.vue?vue&type=template&id=4731efc4&scoped=true"
import script from "./submitPay.vue?vue&type=script&lang=js"
export * from "./submitPay.vue?vue&type=script&lang=js"
import style0 from "./submitPay.vue?vue&type=style&index=0&id=4731efc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731efc4",
  null
  
)

export default component.exports